export default __webpack_public_path__ + "static/media/72.d2cabb71.jpg";